import './App.css';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setAgregarParticipante, setNombreProyecto } from './features/metadata/MetadataLogic'
import { motion } from 'framer-motion'

function App() {

  // REDUX ----------------------------------------------------------
  // Para obtener y modificar la data del individuo en Redux
  const jsonMetadata = useSelector((state) => state.jsonMetadata.value)
  const dispatch = useDispatch()

  const [myName, setMyname] = useState('')
  const [projectName, setProjectName] = useState('')


  let navigate = useNavigate();
  const routeChange = () => {

    if ((!myName == "") && (!projectName == "")) {
      dispatch(setAgregarParticipante({ nombre: myName, tipo: 'host' }))
      dispatch(setNombreProyecto({ projectName }))
      let path = "Configuration";
      navigate(path);
    } else {
      alert('Debes llenar los campos')
    }

  }

  return (
    <motion.div className='App-header' 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <h1 style={{ fontSize: '50px' }}>xPlanningProject</h1>
      <p style={{ marginBottom: '25px' }}>The tool of your dreams for time estimations</p>

      <div className='App'>
        <motion.input type="text" name='userName' animate={{ boxShadow: "10px 10px 0 rgba(0, 0, 0, 0.2)", }}
          className="form-control mb-2 mr-sm-2 inputTexto" placeholder="My Name" value={myName} required='true'
          onChange={(event) => {
            setMyname(event.target.value)
          }} />

        <motion.input type="text" name='projectName' animate={{ boxShadow: "10px 10px 0 rgba(0, 0, 0, 0.2)", }}
          className="form-control mb-2 mr-sm-2 inputTexto" placeholder="Project Name" value={projectName} required='true'
          onChange={(event) => {
            setProjectName(event.target.value)
          }} />

        <button type="submit" className="btn btn-primary" style={{ marginTop: '20px' }} onClick={routeChange}>Siguiente </button>
      </div>
    </motion.div>
  );
}

export default App;
